import React, { FC, ReactNode } from 'react';

import RadioButton, { RadioButtonProps } from '../RadioButton';

import { StyledLabel, StyledRadioWrapper, StyledLabelText } from './RadioItem.styles';

export interface RadioItemProps extends RadioButtonProps {
  /** The name of the radio item */
  name?: string;
  /** The label to display next to the radio item */
  label?: ReactNode;
  /** @ignore */
  horizontal?: boolean;
  /** @ignore */
  noBox?: boolean;
}

export interface RadioItemStatics {
  StyledLabel: typeof StyledLabel;
}

/**
 * @mode developer
 */
const RadioItem: FC<RadioItemProps> & RadioItemStatics = ({ label, disabled, horizontal, noBox, name, readOnly, ...props }) => (
  <StyledLabel
    disabled={disabled}
    readOnly={readOnly}
    data-testid="RadioItem"
    data-test-name={name}
    horizontal={horizontal}
    noBox={noBox}
  >
    <StyledRadioWrapper>
      <RadioButton
        {...props}
        name={name}
        disabled={disabled}
        readOnly={readOnly}
      />
    </StyledRadioWrapper>
    <StyledLabelText horizontal={horizontal}>{label}</StyledLabelText>
  </StyledLabel>
);

RadioItem.StyledLabel = StyledLabel;

export default RadioItem;
